import styled, { css } from "styled-components";
import Box from "./Box";

export default styled(Box)`
  display: grid;
  ${(props) => {
    if (!props.cols) return null;
    if (typeof props.cols === "string") {
      return css`
        grid-template-columns: ${props.cols};
      `;
    } else {
      return css`
        grid-template-columns: ${props.cols[0]};
        @media only screen and (max-width: 1200px) {
          grid-template-columns: ${props.cols[1]};
        }
        @media only screen and (max-width: 992px) {
          grid-template-columns: ${props.cols[2]};
        }
        @media only screen and (max-width: 768px) {
          grid-template-columns: ${props.cols[3]};
        }
        /* grid-template-columns: ${props.cols}; */
      `;
    }
  }}
  ${(props) =>
    props.rows &&
    css`
      grid-template-rows: ${props.rows};
    `}
    ${(props) =>
    props.rowGap &&
    css`
      row-gap: ${props.rowGap}px;
    `};
  ${(props) =>
    props.colGap &&
    css`
      column-gap: ${props.colGap}px;
    `};
  ${(props) =>
    props.gap &&
    css`
      gap: ${props.gap}px;
    `};
`;
